import { SvgColor } from 'src/components/svg-color';

const SvgAssetIcon = (name: string, options?: { color?: string; source?: string }) => {
  const { color, source = 'navbar' } = options || {};
  return (
    <SvgColor src={`/assets/icons/${source}/${name}.svg`} sx={color ? { color } : undefined} />
  );
};

export default SvgAssetIcon;
